/* NY2K Maison homepage (10 Oct 2026). Vanilla, no dependencies. */
(function(){
'use strict';
if(window.mxReady)return;window.mxReady=true;
var d=document,root=d.documentElement,mm=window.matchMedia;
var reduce=!!(mm&&mm('(prefers-reduced-motion: reduce)').matches);
var hover=!!(mm&&mm('(hover: hover) and (pointer: fine)').matches);
var scrubs=[],bar=null,ticking=false,io=null;

/* header height, so the hero fills exactly what is left of the screen */
function head(){
  var b=parseFloat(getComputedStyle(d.body).paddingTop)||0;
  var h=d.getElementById('shopify-section-ny2k-header');
  var v=b||(h?h.offsetHeight:0);
  if(v)root.style.setProperty('--mx-head',Math.round(v)+'px');
}

/* text animate: wrap each word, keep em and br intact */
function split(el){
  var i=0;
  (function walk(n){
    [].slice.call(n.childNodes).forEach(function(c){
      if(c.nodeType===3){
        var f=d.createDocumentFragment();
        c.nodeValue.split(/(\s+)/).forEach(function(t){
          if(!t)return;
          if(/^\s+$/.test(t)){f.appendChild(d.createTextNode(' '));return;}
          var s=d.createElement('span');s.className='mx-w';s.style.setProperty('--i',i++);s.textContent=t;f.appendChild(s);
        });
        n.replaceChild(f,c);
      }else if(c.nodeType===1&&c.tagName!=='BR'){walk(c);}
    });
  })(el);
  el.classList.add('is-split');
}

/* number ticker */
function count(el){
  var to=+el.getAttribute('data-mx-count'),from=+(el.getAttribute('data-mx-from')||0),pad=+(el.getAttribute('data-mx-pad')||0);
  if(isNaN(to))return;
  function fmt(v){v=String(Math.round(v));while(v.length<pad)v='0'+v;return v;}
  if(reduce){el.textContent=fmt(to);return;}
  var t0=performance.now(),dur=1800;
  (function tick(t){var p=Math.min(1,Math.max(0,(t-t0)/dur)),e=1-Math.pow(1-p,4);el.textContent=fmt(from+(to-from)*e);if(p<1)requestAnimationFrame(tick);})(t0);
}

function show(el){el.classList.add('is-in');if(el.hasAttribute('data-mx-count'))count(el);}

if('IntersectionObserver' in window&&!reduce){
  io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){show(e.target);io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:0.1});
}

/* lens: a loupe over the stone photograph */
function lens(el){
  if(!hover||el.mxOn)return;el.mxOn=1;
  var img=el.querySelector('img');if(!img)return;
  var g=d.createElement('div');g.className='mx-lens-glass';g.setAttribute('aria-hidden','true');el.appendChild(g);
  var Z=2.2;
  el.addEventListener('pointerenter',function(){g.style.backgroundImage='url("'+(img.currentSrc||img.src)+'")';el.classList.add('is-on');});
  el.addEventListener('pointerleave',function(){el.classList.remove('is-on');});
  el.addEventListener('pointermove',function(e){
    var r=el.getBoundingClientRect(),x=e.clientX-r.left,y=e.clientY-r.top,s=g.offsetWidth/2;
    var nr=(img.naturalWidth&&img.naturalHeight)?img.naturalWidth/img.naturalHeight:r.width/r.height,cr=r.width/r.height;
    var bw,bh,ox=0,oy=0;
    if(nr>cr){bh=r.height*Z;bw=bh*nr;ox=(bw-r.width*Z)/2;}else{bw=r.width*Z;bh=bw/nr;oy=(bh-r.height*Z)/2;}
    g.style.left=x+'px';g.style.top=y+'px';
    g.style.backgroundSize=bw+'px '+bh+'px';
    g.style.backgroundPosition=(s-x*Z-ox)+'px '+(s-y*Z-oy)+'px';
  });
}

/* hero video: starts after the page has loaded, never for reduced motion or Save-Data */
function video(v){
  if(v.mxOn)return;v.mxOn=1;
  if(reduce||(navigator.connection&&navigator.connection.saveData))return;
  var done=false;
  function go(){if(done)return;done=true;v.muted=true;try{var p=v.play();if(p&&p.catch)p.catch(function(){});}catch(e){}}
  if(d.readyState==='complete')go();else{window.addEventListener('load',go,{once:true});setTimeout(go,5000);}
}

/* text reveal + scroll progress, one rAF-throttled listener */
function frame(){
  ticking=false;
  var vh=window.innerHeight;
  scrubs.forEach(function(s){
    var r=s.el.getBoundingClientRect();
    var p=(vh*0.85-r.top)/(r.height+vh*0.4);p=Math.max(0,Math.min(1,p));
    var n=Math.ceil(p*s.w.length*1.05);
    for(var i=0;i<s.w.length;i++)s.w[i].classList.toggle('is-lit',i<n);
  });
  if(bar){var m=root.scrollHeight-vh;bar.style.transform='scaleX('+(m>0?Math.min(1,window.scrollY/m):0)+')';}
}
function onScroll(){if(!ticking){ticking=true;requestAnimationFrame(frame);}}

function init(scope){
  scope=scope||d;
  scope.querySelectorAll('[data-mx-words]:not(.is-split),[data-mx-scrub]:not(.is-split)').forEach(split);
  scope.querySelectorAll('[data-mx-scrub]').forEach(function(el){if(el.mxOn)return;el.mxOn=1;scrubs.push({el:el,w:el.querySelectorAll('.mx-w')});});
  scope.querySelectorAll('[data-mx-fade]:not(.is-in),[data-mx-words]:not(.is-in),[data-mx-count]:not(.is-in)').forEach(function(el){if(io)io.observe(el);else show(el);});
  scope.querySelectorAll('[data-mx-lens]').forEach(lens);
  scope.querySelectorAll('video[data-mx-video]').forEach(video);
  if(reduce)scope.querySelectorAll('.mx-hero video[autoplay]').forEach(function(v){v.removeAttribute('autoplay');try{v.pause();v.currentTime=0;}catch(e){}});
  scope.querySelectorAll('.mx-cmp input').forEach(function(i){if(i.mxOn)return;i.mxOn=1;var c=i.closest('.mx-cmp');i.addEventListener('input',function(){c.style.setProperty('--p',i.value+'%');});});
  onScroll();
}

/* magic card: the spotlight follows the pointer */
if(hover)d.addEventListener('pointermove',function(e){
  var c=e.target&&e.target.closest?e.target.closest('.mx-card'):null;if(!c)return;
  var r=c.getBoundingClientRect();
  c.style.setProperty('--mx-x',(e.clientX-r.left)+'px');c.style.setProperty('--mx-y',(e.clientY-r.top)+'px');
},{passive:true});

function boot(){
  head();
  if(!(window.Shopify&&window.Shopify.designMode)&&!reduce&&d.querySelector('.mx')){bar=d.createElement('div');bar.className='mx-progress';bar.setAttribute('aria-hidden','true');d.body.appendChild(bar);}
  init(d);
  window.addEventListener('scroll',onScroll,{passive:true});
  window.addEventListener('resize',function(){head();onScroll();},{passive:true});
  d.addEventListener('shopify:section:load',function(e){init(e.target);});
}
if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',boot);else boot();
})();
